// extracted by mini-css-extract-plugin
export default {"searchBox":"registeredUsers_searchBox__1vZ4v","items":"registeredUsers_items__hFDS8","item":"registeredUsers_item__ZPRSJ","text":"registeredUsers_text__-6YZ+"};